export const JobCategoryActionTypes = {
    GET_JobCategory: "GET_JobCategory",
    GET_JobCategory_PENDING: "GET_JobCategory_PENDING",
    GET_JobCategory_FULFILLED: "GET_JobCategory_FULFILLED",

    GET_JobCategory_LIST: "GET_JobCategory_LIST",
    GET_JobCategory_LIST_PENDING: "GET_JobCategory_LIST_PENDING",
    GET_JobCategory_LIST_FULFILLED: "GET_JobCategory_LIST_FULFILLED",

}
export const HistoryActionTypes = {
    ADD_HISTORY: "ADD_HISTORY"
}